import { FC } from 'react';
import { Helmet } from 'react-helmet';

interface MetaTitleProps {
  title: string;
}

const MetaTitle: FC<MetaTitleProps> = ({ title }) => {
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  );
};

export default MetaTitle;
